import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import {
  GlobalService,
  ToastColors,
} from 'src/providers/apiservices/globalservices';
import { LocalStorageProvider } from 'src/providers/apiservices/localstorageprovider';
import { ControleCienteProvider } from '../../../providers/controleciente/controleciente';

@Component({
  selector: 'app-controleciente',
  templateUrl: './controleciente.page.html',
  styleUrls: ['./controleciente.page.scss'],
})
export class ControleCientePage implements OnInit {
  public controleCienteResponse = [];

  constructor(
    public modalController: ModalController,
    private navParams: NavParams,
    private globalServices: GlobalService,
    private controleCienteProvider: ControleCienteProvider,
    private localStorageProvider: LocalStorageProvider,
    private router: Router
  ) {
    // this.titulo = this.navParams.data.titulo;
    // this.type = this.navParams.data.type;
    // this.search();
    // this.setSelected(temp);
  }

  ngOnInit() {
    // this.filtroUpdate
    //   .pipe(debounceTime(400), distinctUntilChanged())
    //   .subscribe((_) => {
    //     this.isLoadingSearch = false;
    //     this.search();
    //   });
  }

  dismiss() {
    if (this.controleCienteResponse == null) {
      return false;
    }

    // if (this.controleCienteResponse.length > 0) {
    //   return this.globalServices.presentToast(
    //     'Ainda há mensagens sem marcação de ciência.',
    //     ToastColors.danger
    //   );
    // }

    this.modalController.dismiss({ completed: true });
  }

  async updateCiente(status, controle) {
    const loading = await this.globalServices.showLoading();

    this.controleCienteResponse.splice(
      this.controleCienteResponse.findIndex((x) => x.guid == controle.guid),
      1
    );

    // console.log('Update', status, controle);

    if (status != 2) {
      const promiseUpdate = this.controleCienteProvider.updateStatusControle(
        controle.codigo,
        controle.tipo,
        status == 2
      );

      if (this.controleCienteResponse.length == 0) {
        this.dismiss();
      }
      promiseUpdate.finally(() => loading.dismiss());
      return;
    }

    try {
      await this.controleCienteProvider.updateStatusControle(
        controle.codigo,
        controle.tipo,
        status == 2
      );

      //this.dismiss()

      // TODO: Abrir todos os tipos para leitura
      // começar fazendo o update do status de ciência, depois abrir o módulo correspondente
      
      const tiposComunicacao = ['1', '2', '3', '4'];

      if (tiposComunicacao.includes(controle.tipo)) {
        const item = {
          intType: 0,
          id: controle.codigo,
        };

        this.goToModule(item, false);
      } else if (controle.tipo == '5') {
        // Boletos
        const item = {
          intType: 2,
          id: controle.codigo,
          titulo: controle.titulo
        };

        this.goToModule(item, false);
      } else if (controle.tipo == '6') {
        // Autorização
        const item = {
          id: controle.codigo,
          intType: 3,
        };

        this.goToModule(item, false);
      } else if (controle.tipo == '7' &&
        controle.titulo &&
        controle.titulo.toLowerCase().startsWith('novo documento disponível'))
      {
        // TODO: O campo `tipo` no controle de ciência é usado para identificar o módulo da notificação
        // (ex.: 7 = informe), mas o documento da biblioteca também pode chegar com esse mesmo campo,
        // e aí o texto do título indica que se trata de um documento da Biblioteca e não de um informe.
        // Esse tratamento especial evita o redirecionamento indevido para /informe.
        // Idealmente, o backend deve devolver um campo explícito para distinguir o tipo da notificação
        // do tipo do documento (ex.: tipoMensagem vs tipoDocumento / moduloDestino).
        // BIBLIOTECA 
        const item = {
          id: controle.codigo,
          intType: 5,
        };

        this.goToModule(item, false);
      } else if (controle.tipo == '7') {
        // Informe
        if (this.controleCienteResponse.length == 0) {
          this.dismiss();
        }

        const item = {
          ...controle,
          id: controle.codigo,
          intType: 4,
        };

        this.goToModule(item, false);
      } else if (controle.tipo == '8') {
        // Informe venda sem salvar
        const item = {
          ...controle,
          id: controle.guid || controle.codigo,
          intType: 4,
        };

        this.goToModule(item, false);
      }
    } catch (e) {
      console.error(e);
      this.globalServices.presentToast(
        'Não foi possível ler neste momento, tente novamente mais tarde...',
        ToastColors.danger
      );
    } finally {
      loading.dismiss();
    }
  }

  isOpeningModuleAction = false;
  async goToModule(notificacao: any, isTarefa = false) {
    if (this.isOpeningModuleAction) {
      return;
    }

    this.isOpeningModuleAction = true;
    console.log('Navigating to module with notificacao:', notificacao);

    try {
      await this.router.navigate(['home']);

      let navigation = null;
      switch (notificacao.intType) {
        case 0:
          navigation = this.router.navigateByUrl('/comunicacao', {
            state: { isTarefa, message: notificacao },
          });
          break;
        case 1:
          navigation = this.router.navigate(['informe'], {
            queryParams: {
              view: 'tarefa',
              id: notificacao['TASK.TKIID'],
              instanceId: notificacao['pI_PIID'],
              idEmpresa: notificacao['bdiD_EMPRESA'],
              dataLimite: notificacao['due'] || notificacao.dataLimite,
            },
          });
          break;
        case 2:
          navigation = this.router.navigate(['cobranca'], {
            queryParams: {
              id: notificacao.id,
              tipo:
                notificacao.titulo === 'Nova Prestação de Contas'
                  ? 'prestacao'
                  : null,
            },
          });

          break;
        case 3:
          navigation = this.router.navigate(['autorizacao'], {
            queryParams: {
              view: isTarefa ? 'tarefa' : 'autorizacao',
              id: notificacao.id,
              taskId: notificacao['TASK.TKIID'],
              instanceId: notificacao['pI_PIID'],
            },
          });
          break;
        case 4:
          navigation = this.router.navigate(['informe']);
          break;
        case 5:
          navigation = this.router.navigate(['biblioteca'], {
            queryParams: {
              view: 'documento',
              id: notificacao.id,
            },
          });
          break;
        default:
          break;
      }

      if (navigation != null) {
        navigation.then((navigationSuccess) => {
          if (navigationSuccess) {
            this.dismiss();
          }
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.isOpeningModuleAction = false;
    }
  }
}
